// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"c664e0f2","453":"c1632507","724":"d7a121b6","937":"419f6647"}[chunkId] + ".chunk.js";
};